import { Component, OnInit, OnChanges, OnDestroy, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from "@angular/core";
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, FormArray, ValidationErrors, RequiredValidator, } from "@angular/forms";
import { Candidate } from "../../../class/candidate";
import { CandidateService } from "../../../service/candidate/candidate.service";
import { TranslateService } from "@ngx-translate/core";
import { Message, FileUpload, RadioButtonModule, SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule, CheckboxModule, } from "primeng/primeng";
import { MapsAPILoader } from "@agm/core";
import { Marker } from "../../../../../interfaces/marker";
import { NotificationsService } from "../../../../../theme/services/notifications/notifications.service";
import { Router, Params, ActivatedRoute } from "@angular/router";
import { UploadFilesService } from "../../../service/upload-files/upload-files.service";
import { config } from "../../../../../../environments/config";
import { HasPermissionService } from "../../../service/has-permission/has-permission.service";
import { formatDate } from "../../../../../theme/functions/formatDate.function";
import { calendarES } from "../../../../../theme/functions/calendarES";
import { Observable } from "rxjs/Observable";
import { ListEps } from "../../../../disability/components/candidate-disabilities/data.constants";
import { CandidateEducationLevelOptions } from "../../../../../shared/constans";
import { AccountService } from '../../../../employee/service/account/account.service';
import { User } from '../../../../employee/class/user';
import { AnyFn } from "@ngrx/store/src/selector";

@Component({
  selector: "app-new-candidate-synergo",
  templateUrl: "./new-candidate-synergo.component.html",
  styleUrls: ["./new-candidate-synergo.component.scss"],
})
export class NewCandidateSynergoComponent implements OnInit {
  @Output() msg: EventEmitter<object> = new EventEmitter<object>();
  @Output() close: EventEmitter<any> = new EventEmitter<any>();
  @Input() verification: boolean;
  @Input() edit: Candidate;
  //@Input() minimum: boolean;
  @Input() barcode: boolean;
  @Input() barcodeRead: string;
  @Input() dailyVisit: boolean;
  @ViewChild("search") public searchElementRef: ElementRef;

  //public fb: FormBuilder;
  public formCandidateSynergo: FormGroup;
  public form_edit_candidate_synergo: FormGroup;
  public form_new_candidate_synergo: FormGroup;
  public editForm: any[] = [];
  public zoom: number;
  public marker: Marker;
  public promiseForm: Promise<any>;
  public totalRecords: number;
  public page: number;
  public per_page: number;
  public sort: string;
  public query: string;
  public es: any;
  public idTypeOptions: any[];
  public genderOptions: any[];
  public civilStatusOptions: any[];
  public stratumOptions: any[];
  public houseTypeOptions: any[];
  public sisbenOptions: any[];
  public femaleHHOptions: any[];
  public ethnicityOptions: any[];
  public ethnicGroupOptions: any[];
  public bloodTypeOptions: any[];
  public weightOptions: any[];
  public shoeSizeOptions: any[];
  public pantSizeOptions: any[];
  public shirtSizeOptions: any[];
  public drivingLicenseOptions: any[];
  public drivingLicenseCatOptions: any[];
  public levelEducationOptions: any[] = CandidateEducationLevelOptions;
  public jobStatusOptions: any[];
  public apiUrl = config.API_ROOT;
  public msgs: Message[];
  private id: any;
  public doRequest: number = 0;
  public heightId: string;
  public countryId: string;
  public administrativeDivisionId: string;
  public municipalityId: string;
  public save_exit: boolean;
  public listEps = ListEps;
  public submitted = false;
  public minimum: boolean = false;
  public selectedCountryIdResidence: number;
  public selectedAdministrativeDivisionResidence: number;
  public selectedCountryIdBirth: number;
  public selectedAdministrativeDivisionBirth: number;
  public selectedGender: string;
  public selectedDrivingLicense: string;

  constructor(
    public fb: FormBuilder,
    public candidateService: CandidateService,
    public translate: TranslateService,
    private ngZone: NgZone,
    private mapsAPILoader: MapsAPILoader,
    private notificationsService: NotificationsService,
    // public uploadFilesService: UploadFilesService,
    public hasPermissionService: HasPermissionService,
    private router: Router,
    private route: ActivatedRoute,
    private accountService: AccountService
  ) {
    this.save_exit = false;

    this.es = calendarES();

    this.idTypeOptions = [
      { label: "C. C.", value: "C. C.", code_sorttime: "CIDCCC" },
      { label: "C. E.", value: "C. E.", code_sorttime: "CIDCEE" },
      { label: "T. I.", value: "T. I.", code_sorttime: "CIDTID" },
      { label: "NIT", value: "NIT", code_sorttime: "CIDNIT" },
      { label: "R. C.", value: "R. C.", code_sorttime: "CIDRCI" },
      { label: "P. E.", value: "P. E.", code_sorttime: "CIDPEP" },
      { label: "P. A.", value: "P. A.", code_sorttime: "CIDPAA" },
      { label: "P. T.", value: "P. T.", code_sorttime: "CIDPAS" },
    ];

    this.genderOptions = [
      { label: 'Femenino', value: 'Femenino', code_sorttime: 'SEXFEM' },
      { label: 'Masculino', value: 'Masculino', code_sorttime: 'SEXHOM' },
      { label: 'No binario', value: 'No binario', code_sorttime: 'SEXBIN' },
    ];

    this.civilStatusOptions = [
      { label: 'Soltero(a)', value: 'Soltero(a)', code_sorttime: 'ECVSOL' },
      { label: 'Unión libre', value: 'Unión libre', code_sorttime: 'ECVLIB' },
      { label: 'Casado(a)', value: 'Casado(a)', code_sorttime: 'ECVCAS' },
      { label: 'Divorciado(a)', value: 'Divorciado(a)', code_sorttime: 'ECVDIV' },
      { label: 'Separado(a)', value: 'Separado(a)', code_sorttime: 'ECVSEP' },
      { label: 'Viudo(a)', value: 'Viudo(a)', code_sorttime: 'ECVVIU' },
    ];

    this.femaleHHOptions = [
      { label: 'Sí', value: 'Sí', status_sorttime: true },
      { label: 'No', value: 'No', status_sorttime: false },
    ];

    this.bloodTypeOptions = [
      { label: 'A-', value: 'A-', code_sorttime: 'TSG003' },
      { label: 'A+', value: 'A+', code_sorttime: 'TSG002' },
      { label: 'AB-', value: 'AB-', code_sorttime: 'TSG007' },
      { label: 'AB+', value: 'AB+', code_sorttime: 'TSG005' },
      { label: 'B-', value: 'B-', code_sorttime: 'TSG006' },
      { label: 'B+', value: 'B+', code_sorttime: 'TSG004' },
      { label: 'O-', value: 'O-', code_sorttime: 'TSG008' },
      { label: 'O+', value: 'O+', code_sorttime: 'TSG001' },
      { label: 'No definido', value: 'No definido', code_sorttime: 'TSG000' },
    ];

    this.weightOptions = [
      { label: 'De 40 a 45 Kg', value: 'De 40 a 45 Kg', code_sorttime: 'PES001' },
      { label: 'De 46 a 50 Kg', value: 'De 46 a 50 Kg', code_sorttime: 'PES002' },
      { label: 'De 51 a 55 Kg', value: 'De 51 a 55 Kg', code_sorttime: 'PES003' },
      { label: 'De 56 a 60 Kg', value: 'De 56 a 60 Kg', code_sorttime: 'PES004' },
      { label: 'De 61 a 65 Kg', value: 'De 61 a 65 Kg', code_sorttime: 'PES005' },
      { label: 'De 66 a 70 Kg', value: 'De 66 a 70 Kg', code_sorttime: 'PES006' },
      { label: 'De 71 a 75 Kg', value: 'De 71 a 75 Kg', code_sorttime: 'PES007' },
      { label: 'De 76 a 80 Kg', value: 'De 76 a 80 Kg', code_sorttime: 'PES008' },
      { label: 'De 81 a 85 Kg', value: 'De 81 a 85 Kg', code_sorttime: 'PES009' },
      { label: 'De 86 a 90 Kg', value: 'De 86 a 90 Kg', code_sorttime: 'PES010' },
      { label: 'De 91 a 95 Kg', value: 'De 91 a 95 Kg', code_sorttime: 'PES011' },
      { label: 'No aplica', value: 'No aplica', code_sorttime: 'PES012' },
    ];

    this.shoeSizeOptions = [
      { label: 'Talla 34', value: 'Talla 34', code_sorttime: 'ZAP011' },
      { label: 'Talla 35', value: 'Talla 35', code_sorttime: 'ZAP001' },
      { label: 'Talla 36', value: 'Talla 36', code_sorttime: 'ZAP002' },
      { label: 'Talla 37', value: 'Talla 37', code_sorttime: 'ZAP003' },
      { label: 'Talla 38', value: 'Talla 38', code_sorttime: 'ZAP004' },
      { label: 'Talla 39', value: 'Talla 39', code_sorttime: 'ZAP005' },
      { label: 'Talla 40', value: 'Talla 40', code_sorttime: 'ZAP006' },
      { label: 'Talla 41', value: 'Talla 41', code_sorttime: 'ZAP007' },
      { label: 'Talla 42', value: 'Talla 42', code_sorttime: 'ZAP008' },
      { label: 'Talla 44', value: 'Talla 43', code_sorttime: 'ZAP009' },
      { label: 'Talla 44', value: 'Talla 44', code_sorttime: 'ZAP010' },
      { label: 'No definido', value: 'No definido', code_sorttime: 'ZAP000' },
    ];

    this.pantSizeOptions = [
      { label: 'Talla 6', value: 'Talla 6', code_sorttime: 'PAN013' },
      { label: 'Talla 8', value: 'Talla 8', code_sorttime: 'PAN006' },
      { label: 'Talla 10', value: 'Talla 10', code_sorttime: 'PAN007' },
      { label: 'Talla 12', value: 'Talla 12', code_sorttime: 'PAN008' },
      { label: 'Talla 14', value: 'Talla 14', code_sorttime: 'PAN009' },
      { label: 'Talla 16', value: 'Talla 16', code_sorttime: 'PAN010' },
      { label: 'Talla 18', value: 'Talla 18', code_sorttime: 'PAN014' },
      { label: 'Talla 20', value: 'Talla 20', code_sorttime: 'PAN015' },
      { label: 'Talla 28', value: 'Talla 28', code_sorttime: 'PAN001' },
      { label: 'Talla 30', value: 'Talla 30', code_sorttime: 'PAN002' },
      { label: 'Talla 32', value: 'Talla 32', code_sorttime: 'PAN003' },
      { label: 'Talla 34', value: 'Talla 34', code_sorttime: 'PAN004' },
      { label: 'Talla 36', value: 'Talla 36', code_sorttime: 'PAN005' },
      { label: 'Talla 38', value: 'Talla 38', code_sorttime: 'PAN011' },
      { label: 'Talla 40', value: 'Talla 40', code_sorttime: 'PAN012' },
      { label: 'No definido', value: 'No definido', code_sorttime: 'PAN000' },
    ];

    this.shirtSizeOptions = [
      { label: 'Talla S', value: 'Talla S', code_sorttime: 'CAM001' },
      { label: 'Talla M', value: 'Talla M', code_sorttime: 'CAM007' },
      { label: 'Talla L', value: 'Talla L', code_sorttime: 'CAM003' },
      { label: 'Talla XL', value: 'Talla XL', code_sorttime: 'CAM004' },
      { label: 'No definido', value: 'No definido', code_sorttime: 'CAM000' },
    ];

    this.drivingLicenseOptions = [
      { label: 'Sí', value: 'Sí', code_sorttime: 'Sí' },
      { label: 'No', value: 'No', code_sorttime: 'No' },
    ];

    this.drivingLicenseCatOptions = [
      { label: 'A1', value: 'A1', code_sorttime: 'A1' },
      { label: 'A2', value: 'A2', code_sorttime: 'A2' },
      { label: 'B1', value: 'B1', code_sorttime: 'B1' },
      { label: 'B2', value: 'B2', code_sorttime: 'B2' },
      { label: 'C1', value: 'C1', code_sorttime: 'C1' },
      { label: 'C2', value: 'C2', code_sorttime: 'C2' },
      { label: 'C3', value: 'C3', code_sorttime: 'C3' },
      { label: 'No aplica', value: 'No aplica', code_sorttime: 'No aplica' },
    ];
  }

  ngOnInit() {
    this.id = +this.route.snapshot.paramMap.get("candidate_id") || 0;

    if (this.id !== 0 && this.id !== undefined) {
      var promiseLoc = this.candidateService
        .infoCandidate(this.id)
        .toPromise()
        .then(
          (response) => {
            this.edit = response.json();

            if (this.edit.expedition_date) {
              this.edit.expedition_date = new Date(this.edit.expedition_date);
            }
            if (this.edit.date_birth) {
              this.edit.date_birth = new Date(this.edit.date_birth);
            }

            this.createCandidateSynergoForm(this.edit);

            this.form_new_candidate_synergo.get('gender').valueChanges.subscribe((value) => {
              this.selectedGender = value;
              if (value !== 'Femenino') {
                this.form_new_candidate_synergo.get('female_hh').reset();
              }
            });

            this.form_new_candidate_synergo.get('driving_license').valueChanges.subscribe((value) => {
              this.selectedDrivingLicense = value;
              if (value !== 'Sí') {
                this.form_new_candidate_synergo.get('driving_license_cat').reset();
              }
            });

            this.doRequest = 1;
          },
          (error) => {
            this.notificationsService.growlNotify(
              "error",
              "ID " + this.id + " no encontrado"
            );
            this.router.navigateByUrl("/pages/selection/candidates-synergo");
          }
        );
    } else {
      this.doRequest = 1;
      this.createCandidateSynergoForm();
      this.form_new_candidate_synergo.get('gender').valueChanges.subscribe((value) => {
        this.selectedGender = value;
        if (value !== 'Femenino') {
          this.form_new_candidate_synergo.get('female_hh').reset();
        }
      });
    }


  }

  createCandidateSynergoForm(data: any = null) {
    data = data || {
      id: this.edit ? this.edit.id : "",
      identification_number: this.edit ? this.edit.identification_number : "",
      mobile: this.edit ? this.edit.mobile : "",
      email: this.edit ? this.edit.email : "",
      activated: this.edit ? this.edit.activated : "",
      id_type: this.edit ? this.edit.id_type : "",
      lastname_1: this.edit ? this.edit.lastname_1 : "",
      lastname_2: this.edit ? this.edit.lastname_2 : "",
      name_1: this.edit ? this.edit.name_1 : "",
      name_2: this.edit ? this.edit.name_2 : "",
      business_id: [2],

      expedition_city: this.edit ? this.edit.expedition_city : "",
      expedition_date: this.edit ? this.edit.expedition_date : "",
      gender: this.edit ? this.edit.gender : "",
      address: this.edit ? this.edit.address : "",
      date_birth: this.edit ? this.edit.date_birth : "",
      profession: this.edit ? this.edit.profession : "",
      childrens: this.edit ? this.edit.childrens : "",
      phone_2: this.edit ? this.edit.phone_2 : "",
      female_hh: this.edit ? this.edit.female_hh : "",
      blood_type: this.edit ? this.edit.blood_type : "",
      shoe_size: this.edit ? this.edit.shoe_size : "",
      pant_size: this.edit ? this.edit.pant_size : "",
      shirt_size: this.edit ? this.edit.shirt_size : "",
      eduacational_level: this.edit ? this.edit.eduacational_level : "",
      residence_country: this.edit ? this.edit.residence_country : "",
      residence_department: this.edit ? this.edit.residence_department : "",
      residence_city: this.edit ? this.edit.residence_city : "",
      birth_country: this.edit ? this.edit.birth_country : "",
      birth_department: this.edit ? this.edit.birth_department : "",
      birth_city: this.edit ? this.edit.birth_city : "",
      driving_license: this.edit ? this.edit.driving_license : "",
      driving_license_cat: this.edit ? this.edit.driving_license_cat : "",
      eps: this.edit ? this.edit.eps : "",
    };

    this.form_new_candidate_synergo = this.fb.group({
      id: [data.id],
      identification_number: [data.identification_number, [Validators.required, Validators.minLength(5), Validators.maxLength(20)]],
      mobile: [data.mobile, [Validators.required, Validators.pattern('^[0-9]+$')]],
      email: [data.email, [Validators.required, Validators.email]],
      activated: [data.activated],
      id_type: [data.id_type, Validators.required],
      lastname_1: [data.lastname_1, [Validators.required, Validators.maxLength(50)]],
      lastname_2: [data.lastname_2, [Validators.required, Validators.maxLength(50)]],
      name_1: [data.name_1, [Validators.required, Validators.maxLength(50)]],
      name_2: [data.name_2, [Validators.maxLength(50)]],
      business_id: [2],

      // en edit
      expedition_city: [data.expedition_city, this.edit ? Validators.required : []],
      expedition_date: [data.expedition_date, this.edit ? Validators.required : []],
      gender: [data.gender, this.edit ? Validators.required : []],
      address: [data.address, this.edit ? Validators.required : []],
      date_birth: [data.date_birth, this.edit ? Validators.required : []],
      profession: [data.profession, this.edit ? Validators.required : []],
      childrens: [data.childrens, this.edit ? Validators.required : []],
      phone_2: [data.phone_2, this.edit ? Validators.required : []],
      female_hh: [data.female_hh],
      blood_type: [data.blood_type, this.edit ? Validators.required : []],
      shoe_size: [data.shoe_size, this.edit ? Validators.required : []],
      pant_size: [data.pant_size, this.edit ? Validators.required : []],
      shirt_size: [data.shirt_size, this.edit ? Validators.required : []],
      eduacational_level: [data.eduacational_level, this.edit ? Validators.required : []],
      residence_country: [data.residence_country, this.edit ? Validators.required : []],
      residence_department: [data.residence_department, this.edit ? Validators.required : []],
      residence_city: [data.residence_city, this.edit ? Validators.required : []],
      birth_country: [data.birth_country, this.edit ? Validators.required : []],
      birth_department: [data.birth_department, this.edit ? Validators.required : []],
      birth_city: [data.birth_city, this.edit ? Validators.required : []],
      driving_license: [data.driving_license, this.edit ? Validators.required : []],
      driving_license_cat: [data.driving_license_cat],
      eps: [data.eps, this.edit ? Validators.required : []],
    });
    return;
  }

  public newCandidate(values) {

    const create_by_id = this.edit ? this.edit.created_by_id : JSON.parse(localStorage.getItem("profile")).employee.id;
    var name;
    var param;

    values.name_1 = values.name_1.trim().toUpperCase();

    if (values.name_2 != null && values.name_2 != "")
      values.name_2 = values.name_2.trim().toUpperCase();

    values.lastname_1 = values.lastname_1.trim().toUpperCase();

    values.lastname_2 = values.lastname_2.trim().toUpperCase();

    name = values.name_1;
    if (values.name_2) name += " " + values.name_2;
    name += " " + values.lastname_1 + " " + values.lastname_2;

    param = {
      'id': this.id,
      'identification_number': values.identification_number,
      'id_type': values.id_type,
      'name': name,
      'lastname_1': values.lastname_1,
      'lastname_2': values.lastname_2,
      'name_1': values.name_1,
      'name_2': values.name_2,
      'email': values.email,
      'business_id': values.business_id,
      'created_by_id': create_by_id,
      'mobile': values.mobile,
    };

    if (this.edit) {

      values.date_birth = formatDate(values.date_birth);
      values.expedition_date = formatDate(values.expedition_date);

      param = {
        ...param,
        'expedition_city': values.expedition_city.id,
        'expedition_date': values.expedition_date,
        'gender': values.gender,
        'address': values.address,
        'date_birth': values.date_birth,
        'profession': values.profession.id,
        'childrens': values.childrens,
        'phone_2': values.phone_2,
        'blood_type': values.blood_type,
        'shoe_size': (values.shoe_size == '' || values.shoe_size == null) ? this.shoeSizeOptions[this.shoeSizeOptions.length - 1].value : values.shoe_size,
        'pant_size': (values.pant_size == '' || values.pant_size == null) ? this.pantSizeOptions[this.pantSizeOptions.length - 1].value : values.pant_size,
        'shirt_size': (values.shirt_size == '' || values.shirt_size == null) ? this.shirtSizeOptions[this.shirtSizeOptions.length - 1].value : values.shirt_size,
        'eduacational_level': values.eduacational_level,
        'residence_country': (values.residence_country == '' || values.residence_country == null) ? null : values.residence_country.id,
        'birth_country': (values.birth_country == '' || values.birth_country == null) ? null : values.birth_country.id,
        'driving_license': (values.driving_license == '' || values.driving_license == null) ? this.drivingLicenseOptions[this.drivingLicenseOptions.length - 1].value : values.driving_license,
        'driving_license_cat': (values.driving_license == 'Sí') ? values.driving_license_cat : this.drivingLicenseCatOptions[this.drivingLicenseCatOptions.length - 1].value,
        'eps': values.eps,
        'female_hh': values.female_hh.value,
        'residence_department': (values.residence_department == '' || values.residence_department == null) ? null : values.residence_department.id,
        'residence_city': (values.residence_city == '' || values.residence_city == null) ? null : values.residence_city.id,
        'birth_department': (values.birth_department == '' || values.birth_department == null) ? null : values.birth_department.id,
        'birth_city': (values.birth_city == '' || values.birth_city == null) ? null : values.birth_city.id,
      };
    } else {
      const string_identification_number = values.identification_number.toString();
      const digits_identification_number = string_identification_number.slice(-4);
      const password = digits_identification_number;
      const password_confirmation = digits_identification_number;

      param = {
        ...param,
        'password': password,
        'password_confirmation': password_confirmation,
      }
    }
    this.addCandidateSynergo(param);
  }

  public addCandidateSynergo(values: any): void {
    if (values) {
      const promise = (this.edit) ? this.candidateService.updateCandidate(this.id, values) : this.candidateService.addCandidateUser(values);
      this.promiseForm = promise.toPromise().then(
        (response) => {
          this.translate.get("saved").subscribe((res: string) => {
            this.notificationsService.growlNotify("success", res);

            if (this.save_exit) {
              this.close.emit(response);
              this.form_new_candidate_synergo.reset();
              this.save_exit = false;
            }
          });

          if (!this.barcode && !this.minimum) {
            this.router.navigateByUrl("/pages/selection/candidates-synergo");
          }
        },
        (error) => {
          const errors_body = JSON.parse(error._body);
          const translations = errors_body.errors.map((element) => {
            let translationKey = element.detail;
            if (element.source && element.source.pointer) {
              translationKey += `, ${element.source.pointer}`;
            }

            return this.translate
              .get(translationKey)
              .map((translation: string) => translation);
          });

          Observable.forkJoin(translations).subscribe((results: string[]) => {
            const combinedMessage = results.join(" ");
            this.notificationsService.growlNotify("error", combinedMessage);
          });
        }
      );
    }
  }

  public transferBusiness(values, business_id) {
    this.transferCandidate(values, business_id);
    this.save_exit = true;
  }

  public transferCandidate(values, business_id: any): void {
    if (values && business_id) {
      this.promiseForm = this.candidateService.transferCandidate(values, business_id).toPromise().then(
        (response) => {
          this.translate.get("transfer").subscribe((res: string) => {
            this.notificationsService.growlNotify("success", res);

            if (this.save_exit) {
              this.close.emit(response);
              // this.formCandidateSynergo.reset();
              this.router.navigateByUrl("/pages/selection/candidates-synergo");
              this.save_exit = false;
            }
          });
        },
        (error) => {
          const errors_body = JSON.parse(error._body);
          const translations = errors_body.errors.map((element) => {
            let translationKey = element.detail;
            if (element.source && element.source.pointer) {
              translationKey += `, ${element.source.pointer}`;
            }
            return this.translate
              .get(translationKey)
              .map((translation: string) => translation);
          });
          Observable.forkJoin(translations).subscribe((results: string[]) => {
            const combinedMessage = results.join(" ");
            this.notificationsService.growlNotify("error", combinedMessage);
          });
        }
      );
    }
  }

  public cancel() {
    this.form_new_candidate_synergo.reset();
    this.router.navigateByUrl("/pages/selection/candidates-synergo");
    this.close.emit();
  }

  public saveandexit(values) {
    this.newCandidate(values);
    this.save_exit = true;
  }

  getFormValidationErrors(formCandidateSynergo) {
    let value = "";
    Object.keys(formCandidateSynergo.controls).forEach((key) => {
      const controlErrors: ValidationErrors = this.formCandidateSynergo.get(key).errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach((keyError) => {
          value = "Key control: " + key + ", keyError: " + keyError + ", err value: " + controlErrors[keyError];
        });
      }
    });
    return value;
  }

  onCountryChangeResidence(countryId: any) {
    if (countryId)
      this.selectedCountryIdResidence = countryId.id;
  }

  onAdministrativeDivisionChangeResidence(administrativeDivisionId: any) {
    if (administrativeDivisionId)
      this.selectedAdministrativeDivisionResidence = administrativeDivisionId.id;
  }

  onCountryChangeBirth(countryId: any) {
    if (countryId)
      this.selectedCountryIdBirth = countryId.id;
  }

  onAdministrativeDivisionChangeBirth(administrativeDivisionId: any) {
    if (administrativeDivisionId)
      this.selectedAdministrativeDivisionBirth = administrativeDivisionId.id;
  }
}




// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/candidates-synergo/new-candidate-synergo/new-candidate-synergo.component.ts